'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _breakpoints = require('../utils/breakpoints');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function (theme) {
  var hidden = {
    display: 'none !important'
  };

  return _breakpoints.keys.reduce(function (acc, key) {
    acc['only-' + key] = _defineProperty({}, theme.breakpoints.only(key), hidden);

    acc[key + 'Up'] = _defineProperty({}, theme.breakpoints.up(key), hidden);

    acc[key + 'Down'] = _defineProperty({}, theme.breakpoints.down(key), hidden);

    return acc;
  }, {});
};

function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      lgDown = props.lgDown,
      lgUp = props.lgUp,
      mdDown = props.mdDown,
      mdUp = props.mdUp,
      only = props.only,
      smDown = props.smDown,
      smUp = props.smUp,
      xlDown = props.xlDown,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      xsUp = props.xsUp,
      theme = props.theme,
      other = _objectWithoutProperties(props, ['children', 'classes', 'className', 'component', 'lgDown', 'lgUp', 'mdDown', 'mdUp', 'only', 'smDown', 'smUp', 'xlDown', 'xlUp', 'xsDown', 'xsUp', 'theme']);

  var classNames = [];

  if (classNameProp) {
    classNames.push(classNameProp);
  }

  for (var i = 0; i < _breakpoints.keys.length; i += 1) {
    var breakpoint = _breakpoints.keys[i];
    var breakpointUp = props[breakpoint + 'Up'];
    var breakpointDown = props[breakpoint + 'Down'];

    if (breakpointUp) {
      classNames.push(classes[breakpoint + 'Up']);
    }
    if (breakpointDown) {
      classNames.push(classes[breakpoint + 'Down']);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      classNames.push(classes['only-' + breakpoint]);
    });
  }

  return _react2.default.createElement(
    Component,
    _extends({
      className: classNames.join(' ')
    }, other),
    children
  );
}

HiddenCss.displayName = 'HiddenCss';
HiddenCss.propTypes = {
  children: _propTypes2.default.node,

  classes: _propTypes2.default.object.isRequired,

  className: _propTypes2.default.string,

  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),

  lgDown: _propTypes2.default.bool,

  lgUp: _propTypes2.default.bool,

  mdDown: _propTypes2.default.bool,

  mdUp: _propTypes2.default.bool,

  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  smDown: _propTypes2.default.bool,

  smUp: _propTypes2.default.bool,

  xlDown: _propTypes2.default.bool,

  xlUp: _propTypes2.default.bool,

  xsDown: _propTypes2.default.bool,

  xsUp: _propTypes2.default.bool

};

HiddenCss.defaultProps = {
  component: 'div'
};

exports.default = (0, _reactJss2.default)(styles)(HiddenCss);